<template>
  <div></div>
</template>

<script>
export default {
  methods: {
    emitResize() {
      this.$emit('resize');
    },
  },
  beforeMount() {
    window.addEventListener('resize', this.emitResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.emitResize);
  },
}
</script>